import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card, CardContent, Button, Table, TableHead, TableRow, TableCell,
  TableBody, Chip, Alert, Stack, IconButton, CircularProgress, Box,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AssessmentIcon from '@mui/icons-material/Assessment';
import QuizLayout from './QuizLayout';
import AdminGate from './AdminGate';
import AdminResultsDialog from './AdminResultsDialog';
import { quizService } from './quizService';

function AdminQuizListInner({ pass }) {
  const navigate = useNavigate();
  const [quizzes, setQuizzes] = useState(null);
  const [error, setError] = useState('');
  const [resultsFor, setResultsFor] = useState(null);

  const load = useCallback(() => {
    quizService.adminList(pass).then(setQuizzes).catch((e) => setError(e.message));
  }, [pass]);

  useEffect(() => { load(); }, [load]);

  const remove = async (id) => {
    if (!window.confirm('Delete this quiz and all its attempts?')) return;
    try { await quizService.adminDelete(id, pass); load(); }
    catch (e) { setError(e.message); }
  };

  const action = (
    <Stack direction="row" spacing={1}>
      <Button variant="outlined" onClick={() => navigate('/quizzes')} data-testid="view-quizzes">
        Quizzes
      </Button>
      <Button variant="contained" onClick={() => navigate('/admin/quizzes/new/edit')} data-testid="new-quiz">
        New quiz
      </Button>
    </Stack>
  );

  return (
    <QuizLayout title="Manage Quizzes" action={action}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {!quizzes && !error && <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress /></Box>}
      {quizzes && quizzes.length === 0 && <Alert severity="info">No quizzes yet. Create one.</Alert>}
      {quizzes && quizzes.length > 0 && (
        <Card><CardContent>
          <Table>
            <TableHead><TableRow>
              <TableCell>Title</TableCell><TableCell>Category</TableCell>
              <TableCell>Status</TableCell><TableCell>Questions</TableCell><TableCell align="right">Actions</TableCell>
            </TableRow></TableHead>
            <TableBody>
              {quizzes.map((q) => (
                <TableRow key={q.id}>
                  <TableCell>{q.title}</TableCell>
                  <TableCell>{q.category || '—'}</TableCell>
                  <TableCell><Chip size="small" color={q.is_published ? 'success' : 'default'} label={q.is_published ? 'Published' : 'Draft'} /></TableCell>
                  <TableCell>{q.question_count}</TableCell>
                  <TableCell align="right">
                    <Stack direction="row" justifyContent="flex-end">
                      <IconButton size="small" title="Results" onClick={() => setResultsFor(q.id)}><AssessmentIcon fontSize="small" /></IconButton>
                      <IconButton size="small" title="Edit" onClick={() => navigate(`/admin/quizzes/${q.id}/edit`)}><EditIcon fontSize="small" /></IconButton>
                      <IconButton size="small" title="Delete" onClick={() => remove(q.id)}><DeleteIcon fontSize="small" /></IconButton>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent></Card>
      )}
      {resultsFor && <AdminResultsDialog quizId={resultsFor} pass={pass} onClose={() => setResultsFor(null)} />}
    </QuizLayout>
  );
}

export default function AdminQuizList() {
  return <AdminGate>{(pass) => <AdminQuizListInner pass={pass} />}</AdminGate>;
}
